export default __webpack_public_path__ + "static/media/hotellocal_hotel.9a290ce3.svg";